// TODO: @lisilinhart we can probably remove this function in the future
// it's only used in a single place in `arrayUtils` when the "old way" is used

// TODO: @emanuelgsouza we need to add tests and refactor this code to
// understand how it should work to be used in the arrayUtils.find method

export default function decycle(object, replacer): unknown {
  const objects = [] // Keep a reference to each unique object or array
  const paths = [] // Keep the path to each unique object or array

  return (function derez(value, path): unknown {
    let i // The loop counter
    let nu // The new object or array

    if (replacer !== undefined) {
      value = replacer(value)
    }

    if (
      typeof value === 'object' &&
      value !== null &&
      !(value instanceof Boolean) &&
      !(value instanceof Date) &&
      !(value instanceof Number) &&
      !(value instanceof RegExp) &&
      !(value instanceof String)
    ) {
      i = objects.indexOf(value)
      if (i >= 0) {
        return { $ref: paths[i] }
      }

      objects.push(value)
      paths.push(path)

      if (Array.isArray(value)) {
        nu = []
        value.forEach(function (element, i) {
          nu[i] = derez(element, path + '[' + i + ']')
        })
      } else {
        nu = {}
        Object.keys(value).forEach(function (name) {
          nu[name] = derez(value[name], path + '[' + JSON.stringify(name) + ']')
        })
      }
      return nu
    }
    return value
  })(object, '$')
}
